export default __webpack_public_path__ + "static/media/AAPG-Logo.34d65cf5.png";